'use strict';

var _themeSections = require('@shopify/theme-sections');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('slick-carousel');

var _player = require('@vimeo/player');

var _player2 = _interopRequireDefault(_player);

var _video = require('../modules/video.js');

var videoMod = _interopRequireWildcard(_video);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectors = {
  slider: '[data-featured-products-slider]',
  render: '[data-slide-render]',
  currentSlideNum: '[data-current-slide]',
  video: '[data-video]',
  info: '[data-slide-info]'
};

(0, _themeSections.register)('featured-products', {

  onLoad: function onLoad() {

    var container = this.container;
    var sectionSlider = this.container.querySelector(selectors.slider);
    (0, _jquery2.default)(window).on("load", function () {
      (0, _jquery2.default)(sectionSlider).slick({
        dots: false,
        arrows: true,
        slidesToShow: 1,
        infinite: true,
        centerMode: true,
        centerPadding: '15%',
        respondTo: 'min',
        focusOnSelect: false,
        swipe: true,
        draggable: true,
        prevArrow: container.querySelector('.prev'),
        nextArrow: container.querySelector('.next'),
        responsive: [{
          breakpoint: 600,
          settings: {
            centerPadding: '50px',
            arrows: false,
            dots: true
          }
        }, {
          breakpoint: 900,
          settings: {
            arrows: false,
            centerPadding: '100px'
          }
        }]
      }).on('afterChange', function (event, slick, currentSlide) {
        var current = (0, _jquery2.default)(slick.$slides[currentSlide]);
        sectionSlider.querySelectorAll(selectors.info).forEach(function (item) {
          return item.classList.add("hidden");
        });
        var info = current[0].querySelector(selectors.info);
        info.classList.remove("hidden");
        var currentSlideNum = container.querySelector(selectors.currentSlideNum);
        currentSlideNum.innerHTML = currentSlide + 1;
      }).on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        var current = (0, _jquery2.default)(slick.$slides[currentSlide]);
        var video = current[0].querySelector(selectors.video);
        if (video) {
          if (video.classList.contains("htmlVideo")) {
            video.querySelector('video').pause();
          } else {
            var player = new _player2.default(video);
            player.pause();
          }
          video.classList.add("hidden");
          var playButton = current[0].querySelector(videoMod.selectors.playButton);
          if (playButton) {
            playButton.classList.remove("hidden");
          }
        }
        var image = current[0].querySelector(videoMod.selectors.image);
        if (image) {
          image.classList.remove("hidden");
        }
      });

      videoMod.init();
    });
  },

  onBlockSelect: function onBlockSelect(event) {
    var slideIndex = sectionSlider.querySelector('[data-block-id="' + event + '"]').getAttribute("data-slide");
    (0, _jquery2.default)(sectionSlider).slick('slickGoTo', parseInt(slideIndex));
  }

});